/**
 * Color palette shared by all Share of Voice charts:
 * - ShareOfVoicePieChart (donut chart)
 * - ShareOfVoiceBarChart (stacked bar chart via prepareAndGetColorsForPieChart)
 *
 * SELECTED_BRAND_COLOR (#53CBA2) is intentionally absent — it is injected
 * automatically by getPieChartPalette() / prepareAndGetColorsForPieChart()
 * for whichever slice/bar matches the selected brand.
 */
export const SOV_PIE_CHART_PALETTE = [
  '#1A5E8A', // Steel blue
  '#2E86AB', // Cerulean
  '#2D6A4F', // Forest green
  '#55775e', // Sage green
  '#495057', // Slate gray
  '#5E548E', // Muted violet
  '#6D9E7E', // Dusty teal
  '#868E96', // Mid gray
  '#A07850', // Warm tan
  '#4A7FA5', // Denim blue
  '#C0602A', // Burnt orange
  '#B5476A', // Dusty rose
  '#7B6FA0', // Soft purple
  '#2D8C8C', // Teal
  '#8B7355', // Khaki
  '#CED4DA', // Light gray
];